export default __webpack_public_path__ + "static/184-423441ede5dd424e8234d3f56208a6ec.gif";